import { defaultCustomer, ICustomer } from "./ICustomer";
import { defaultOrganisation, IOrganisation } from "./IOrganisation";
import { defaultPrinter, IPrinter } from "./IPrinter";
import { IReceiptRow } from "./IReceiptRow";

export interface IReceipt {
  id: number;
  user: string;
  customerReceiptNumber: number;
  organisation: IOrganisation;
  customer: ICustomer;
  transactionType: string;
  paymentType: string;
  createdAt: Date;
  rows: IReceiptRow[];
  total: number;
  endComment: string;
  enteredValue: string;
  changeGiven: string;
  printerSettings: IPrinter[];
  table: string;
}

export const defaultReceipt: IReceipt = {
  id: 0,
  user: "",
  customerReceiptNumber: 0,
  organisation: defaultOrganisation,
  customer: defaultCustomer,
  transactionType: "",
  paymentType: "",
  createdAt: new Date(),
  rows: [],
  total: 0,
  endComment: "",
  enteredValue: "",
  changeGiven: "",
  printerSettings: [],
  table: "",
};
